import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/loan/no-data.png';
const _withScopeId = n => (_pushScopeId("data-v-3cb5d392"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "select-wrap"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = {
  key: 0,
  class: "flex-row flex-items-center"
};
const _hoisted_4 = {
  class: "token-icon"
};
const _hoisted_5 = {
  class: "token-text"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "sfe-icon-search"
}, null, -1));
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "token-icon"
};
const _hoisted_10 = {
  key: 1,
  class: "no-data flex-col-center flex-items-center"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "no-data-icon"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _directive_image = _resolveDirective("image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tooltip, {
    placement: "bottom-start",
    trigger: "click",
    teleported: false,
    "show-arrow": false,
    manual: true,
    "hide-after": 50,
    "popper-class": "select-wrap-tooltip",
    "popper-options": $setup.popperOptions,
    visible: $setup.visible,
    "onUpdate:visible": _cache[2] || (_cache[2] = $event => $setup.visible = $event),
    disabled: $props.disabled
  }, {
    content: _withCtx(() => [_createElementVNode("div", {
      class: "search-token-wrap",
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
    }, [_createVNode(_component_el_input, {
      class: "search-token",
      modelValue: $setup.searchToken,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.searchToken = $event),
      placeholder: $setup.t('search'),
      clearable: "",
      onInput: _ctx.inputSearchToken
    }, {
      prefix: _withCtx(() => [_hoisted_6]),
      _: 1
    }, 8, ["modelValue", "placeholder", "onInput"])]), _createVNode(_component_el_scrollbar, {
      class: "options-wrap",
      "max-height": "264px"
    }, {
      default: _withCtx(() => [$setup.filterData && $setup.filterData.length ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterData, item => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass(["flex-row flex-items-center", {
            'active': item.token === $setup.selectedValue.token
          }]),
          key: item.token,
          onClick: $event => _ctx.handleSelect(item)
        }, [_withDirectives(_createElementVNode("span", _hoisted_9, null, 512), [[_directive_image, item.iconDay]]), _createTextVNode(" " + _toDisplayString(item.tokenName), 1)], 10, _hoisted_8);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createElementVNode("p", null, _toDisplayString($setup.t('result_not_found')), 1)]))]),
      _: 1
    })]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: "select-button flex-row-space-between flex-items-center",
      id: $setup.selectRef
    }, [$setup.selectedValue ? (_openBlock(), _createElementBlock("p", _hoisted_3, [_withDirectives(_createElementVNode("span", _hoisted_4, null, 512), [[_directive_image, $setup.selectedValue?.iconDay]]), _createElementVNode("span", _hoisted_5, _toDisplayString($setup.selectedValue.tokenName), 1)])) : _createCommentVNode("", true), !$props.disabled ? (_openBlock(), _createElementBlock("i", {
      key: 1,
      class: _normalizeClass(['sfe-icon-arrow-right', $setup.visible && 'open'])
    }, null, 2)) : _createCommentVNode("", true)], 8, _hoisted_2)]),
    _: 1
  }, 8, ["popper-options", "visible", "disabled"])]);
}